import createCachedSelector from 're-reselect'
import { selectProduct } from './selectProduct'

export const selectIsTrial = createCachedSelector(selectProduct, plan => {
  return plan?.state === 'trial'
})((_state, product) => product || 'unknown')
